module.exports = __webpack_public_path__ + "static/image-01-b@2x-61c851e8c7bd5e358840c6e63db97997.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/buzzfeed/image-01-b@2x.jpg
// module id = 328
// module chunks = 3627797113349 20562973939449 33019919093843